import { Box } from "@chakra-ui/react";
import DropDown from "./components/DropDown";
import PopUp from "./components/PopUp";
import SearchBar from "./components/SearchBar";
import Tabs from "./components/Tabs";
import Drawer from "./components/Drawer";
import Header from "./components/Header";
import Password from "./components/Password";
import Button from "./components/Button";
import AdvanceWork from "./components/AdvanceWork";
import Accordion from "./components/Accordion";

function App() {
  return (
    <Box>
      <Header />
      <DropDown />
      <PopUp />
      <SearchBar />
      <Tabs />
      <Drawer />
      <Password />
      <Button />
      <Accordion />
      <AdvanceWork />
    </Box>
  );
}

export default App;

// bolder  ==== Protest Riot
